import styled from 'styled-components';

export default styled.div`
  .bottom-wrap {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    span {
      padding-bottom: 16px;
    }
    small {
      padding: 16px 0 0 0;
      margin: 0 auto;
    }
    button {
      width: 100%;
    }
  }
`;
